import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";
import "./ContactUs.css";

const EMAILJS_SERVICE_ID = "service_9pi0xsg";
const EMAILJS_TEMPLATE_ID = "template_jx9lqap";
const EMAILJS_PUBLIC_KEY = "Mo-dlqezg99L1ER4e";

const RECAPTCHA_SITE_KEY = "6Le68RktAAAAAGGT-CYDcee0uL_NV8PDF_SxaoD_";

export default function ContactUs({
    onSubmit,
    socials = [
        {
            icon: "/img/Logos/linkedin_white.png",
            label: "/university-hub-latam",
            href: "https://www.linkedin.com/company/university-hub-latam/?originalSubdomain=ar",
        },
        {
            icon: "/img/Logos/ig_white.png",
            label: "@uhublatam",
            href: "https://www.instagram.com/uhublatam/",
        },
        {
            icon: null,
            label: "contact@uhublatam.com",
            href: "mailto:contact@uhublatam.com",
        },
    ],
}) {
    const formRef = useRef(null);
    const recaptchaRef = useRef(null);
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [status, setStatus] = useState(null); // null | 'sending' | 'success' | 'error'

    function handleSubmit(e) {
        e.preventDefault();
        if (!captchaVerified) {
            alert("Por favor, completá el captcha antes de enviar.");
            return;
        }
        setStatus('sending');
        emailjs
            .sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, formRef.current, EMAILJS_PUBLIC_KEY)
            .then(() => {
                setStatus('success');
                formRef.current.reset();
                recaptchaRef.current?.reset();
                setCaptchaVerified(false);
            })
            .catch(() => setStatus('error'));
    }

    return (
        <section id="contact" className="contact">
            <div className="contact-inner">
                <div className="contact-grid">
                    {/* LEFT SIDE: channels */}
                    <div className="contact-left">
                        <h2 className="contact-heading">CANALES OFICIALES</h2>

                        <p className="contact-copy">
                            Si tenes un interés por conectar distinto con tu audiencia, este
                            es el primer paso:
                        </p>

                        <ul className="contact-socials" aria-label="Canales oficiales">
                            {socials.map((s) => (
                                <li className="contact-social" key={s.label}>
                                    <a
                                        href={s.href}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        className="contact-social-link"
                                    >
                                        {s.icon ? (
                                            <img
                                                src={s.icon}
                                                alt=""
                                                aria-hidden="true"
                                                className="contact-social-icon"
                                            />
                                        ) : (
                                            <svg
                                                className="contact-social-icon"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="1.8"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                aria-hidden="true"
                                            >
                                                <rect x="2" y="4" width="20" height="16" rx="2" />
                                                <polyline points="2,4 12,13 22,4" />
                                            </svg>
                                        )}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        <a
                            href="mailto:contact@uhub.com"
                            className="contact-email-link"
                        >
                            CONTACT@UHUBLATAM.COM
                        </a>
                    </div>

                    {/* RIGHT SIDE: form */}
                    <div className="contact-right">
                        <h2 className="contact-form-heading">DEJANOS TU CONSULTA</h2>


                        <form
                            ref={formRef}
                            className="contact-form"
                            onSubmit={handleSubmit}
                        >
                            <div className="contact-row contact-row-top">
                                <label className="field">
                                    <span className="field-label">Nombre completo</span>
                                    <input
                                        type="text"
                                        name="name"
                                        required
                                        autoComplete="name"
                                    />
                                </label>

                                <label className="field">
                                    <span className="field-label">Email</span>
                                    <input
                                        type="email"
                                        name="email"
                                        required
                                        autoComplete="email"
                                    />
                                </label>

                                <label className="field">
                                    <span className="field-label">Celular</span>
                                    <input
                                        type="tel"
                                        name="phone"
                                        autoComplete="tel"
                                    />
                                </label>
                            </div>

                            <div className="contact-row">
                                <label className="field field-wide">
                                    <span className="field-label">Consulta</span>
                                    <textarea
                                        name="message"
                                        rows={3}
                                        required
                                    />
                                </label>
                            </div>



                            <div className="contact-captcha">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey={RECAPTCHA_SITE_KEY}
                                    onChange={(token) => setCaptchaVerified(!!token)}
                                    onExpired={() => setCaptchaVerified(false)}
                                />
                            </div>

                            {status === 'success' && (
                                <p className="contact-feedback contact-feedback--success">
                                    ¡Mensaje enviado! Te contactamos pronto.
                                </p>
                            )}
                            {status === 'error' && (
                                <p className="contact-feedback contact-feedback--error">
                                    Hubo un error al enviar. Intentá de nuevo.
                                </p>
                            )}

                            <div className="contact-actions">
                                <button
                                    type="submit"
                                    className="contact-submit"
                                    disabled={!captchaVerified || status === 'sending'}
                                >
                                    {status === 'sending' ? 'Enviando...' : 'Contáctanos'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}
